import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function PublishNotification({
  open,
  newsArticle,
  setOpen,
  onSubmit,
  title = "Publish Notification",
  item = "Load Shedding Update",
  isLoading,
}) {
  return (
    <ModalComp
      title={title}
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={isLoading}
          handleSecondaryBtn={onSubmit}
          secondaryBtnText="Publish"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      Are you sure you want to publish the{" "}
      {newsArticle ? "news article" : "notification"} titled '{item}'?
    </ModalComp>
  );
}

export default PublishNotification;
